import { apiRequestWithChecks } from "./api";

export const customContacs = {

    deleteCustomContact: function (token, customContactTypeId) {
        return apiRequestWithChecks(
            "DELETE",
            `/api/customcontacttypes/delete/${customContactTypeId}`,
            {
                Authorization: "Bearer " + token,
            }
        );
    },
    deleteCustomContactTypeForSpecificUser: function (token, customContactTypeId, userId) {
        return apiRequestWithChecks(
            "DELETE",
            `/api/customcontacttypes/DeleteCustomContactTypeForSpecificUser?customContactTypeId=${customContactTypeId}&userId=${userId}`,
            {
                Authorization: "Bearer " + token,
            }
        );
    },
    saveCustomType: function (token, payload) {
        return apiRequestWithChecks(
            "PUT",
            "/api/customcontacttypes/save",
            {
                Authorization: "Bearer " + token,
            },
            payload
        );
    },
    saveCustomContactTypeForSpecificUser: function (token, payload, userId) {
        return apiRequestWithChecks(
            "PUT",
            `/api/customcontacttypes/SaveCustomContactTypeForSpecificUser?userId=${userId}`,
            {
                Authorization: "Bearer " + token,
            },
            payload
        );
    },
    editCustomContact: function (token, customContactTypeId, payload) {
        return apiRequestWithChecks(
            "POST",
            `/api/customcontacttypes/edit/${customContactTypeId}`,
            {
                Authorization: "Bearer " + token,
            },
            payload
        );
    },
    editCustomContactTypeForSpecificUser: function (token, customContactTypeId, payload, userId) {
        return apiRequestWithChecks(
            "POST",
            `/api/customcontacttypes/EditCustomContactTypeForSpecificUser?customContactTypeId=${customContactTypeId}&userId=${userId}`,
            {
                Authorization: "Bearer " + token,
            },
            payload
        );
    }
};
